import { useWithdrawalMethodById } from '../../../api';
import { useWithdrawSearchParams } from '../useWithdrawSearchParams';
import { UseSelectedWithdrawalMethodProps } from './props';

/**
 * Custom hook to retrieve the selected withdrawal method by its ID.
 * This hook uses the withdrawal method ID from the search parameters and fetches the corresponding withdrawal method.
 *
 * @param {UseSelectedWithdrawalMethodProps} [props] - The properties for the hook.
 * @param {boolean} [props.enabled=true] - Flag to enable or disable the hook.
 * @returns {Object} An object containing the withdrawal method information.
 *
 * @example
 * // Usage example:
 * const { data, error, isLoading } = useSelectedWithdrawalMethod({ enabled: true });
 */
export function useSelectedWithdrawalMethod(
  props?: UseSelectedWithdrawalMethodProps,
) {
  // Destructure the enabled flag from props, defaulting to true if not provided
  const { enabled = true } = props ?? {};
  // Retrieve the withdrawal method ID from the search parameters
  const { withdrawMethodId } = useWithdrawSearchParams();

  // Fetch the withdrawal method by its ID using the useWithdrawalMethodById hook
  return useWithdrawalMethodById({
    id: withdrawMethodId as unknown as bigint,
    enabled,
  });
}

export type { UseSelectedWithdrawalMethodProps };
